import React from 'react';

export declare type FocusType = 'false' | 'true';

export type IconProps = {
  className?: string;
  color?: string;
  focusable?: FocusType;
  height?: number;
  onClick?: () => void;
  size?: number;
  width?: number;
};

export const KeyboardArrowDown: React.FC<
  IconProps & JSX.IntrinsicElements['svg']
> = ({
  className = '',
  color = '#233f53',
  focusable = 'false',
  height,
  onClick,
  size = 24,
  width,
  ...rest
}) => {
  const iconColor = undefined;

  return (
    <svg
      fill={iconColor || color}
      height={height || size}
      width={width || size}
      onClick={onClick}
      className={className}
      focusable={focusable}
      {...rest}
      viewBox="0 0 24 24"
    >
      <path d="M16.375 9.22a1 1 0 011.343 1.476l-.093.085-5 4a1 1 0 01-1.146.072l-.104-.072-5-4a1 1 0 011.147-1.634l.103.072L12 12.72l4.375-3.5z" />
    </svg>
  );
};
